/**
 * Strips contact details out of free text before it's sent to analytics (the questions visitors type
 * into the lead form's chat, and Luna's answers). Emails and phone numbers become placeholders; other
 * numbers (scores, grades, ZIP codes, prices) stay, since they're what the questions are about.
 */
const EMAIL = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}/gi;
// 10 or 11 digits, optionally +1, with spaces, dots, dashes or parentheses between groups.
const PHONE = /(?:\+?1[\s.-]?)?(?:\(\d{3}\)|\d{3})[\s.-]?\d{3}[\s.-]?\d{4}\b/g;
// Any other run of 9 or more digits (an SSN, a card or account number).
const LONG_NUMBER = /\b(?:\d[\s-]?){8,}\d\b/g;

export const redactPii = (text: string, maxLength = 1000): string =>
  text.replace(EMAIL, '[email]').replace(PHONE, '[phone]').replace(LONG_NUMBER, '[number]').slice(0, maxLength);
